/*==================================================
HERSHOP INFO
==================================================*/

document.addEventListener("DOMContentLoaded", () => {

    const cards = document.querySelectorAll(".hershop-info__card");

    cards.forEach((card) => {

        const button = card.querySelector(".hershop-info__toggle");
        const content = card.querySelector(".hershop-info__content");

        content.style.display = "none";
        content.style.overflow = "hidden";
        content.style.maxHeight = "0px";
        content.style.transition =
            "max-height .45s cubic-bezier(.22,.61,.36,1), opacity .35s ease";

        content.style.opacity = "0";

        button.addEventListener("click", () => {

            const opened = card.classList.contains("active");

            cards.forEach((item) => {

                item.classList.remove("active");

                const c = item.querySelector(".hershop-info__content");

                c.style.maxHeight = "0px";
                c.style.opacity = "0";

                setTimeout(() => {

                    if (!item.classList.contains("active")) {
                        c.style.display = "none";
                    }

                }, 350);

            });

            if (opened) return;

            card.classList.add("active");

            content.style.display = "block";

            requestAnimationFrame(() => {

                content.style.maxHeight =
                    content.scrollHeight + "px";

                content.style.opacity = "1";

            });

        });

    });

});